const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate pseudoContentArrayReduceBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const values = await evaluateSource(source.values, content, parentContentPath, transientContext, nativeFunctions);
  if (values === undefined || !Array.isArray(values)) {
    return undefined;
  }
  const context = await evaluateSource(source.context, content, parentContentPath, transientContext, nativeFunctions);
  let accumulator = await evaluateSource(source.accumulator, content, parentContentPath, transientContext, nativeFunctions);
  let index;
  for (index = 0; index < values.length; index += 1) {
    const value = values[index];
    const pseudoContent = {
      accumulator,
      context,
      index,
      value,
      values
    };
    // eslint-disable-next-line no-await-in-loop
    accumulator = await evaluateSource(source.valueReduce, pseudoContent, '', transientContext, nativeFunctions);
  }
  return accumulator;
};
module.exports = {
  evaluate
};